import { getArchivedChatsV2 } from './getArchivedChatsV2';
import { getLastTimeStamp } from '../../reducers/chatList/helpers';
import { TThunkAction } from '../../types/redux/thunk';
import { EChatListTrigger } from '../../utils/logging/publicApiDiagnostics';

export const getArchivedListNextPage = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();
  const { chatList } = state;

  const timestampArchive = chatList.isFirstLoad
    ? undefined
    : chatList.chats.length
      ? getLastTimeStamp(chatList.chats)
      : state.chatList.timestampArchive;

  const trigger = chatList.isFirstLoad ? EChatListTrigger.FirstLoad : EChatListTrigger.NextPage;

  dispatch(getArchivedChatsV2({ timestampArchive }, trigger));
};
